import { Icons } from '@/assets/icons/icons';
import { Button } from '@/components/ui/Button';
import { DropdownMenu } from '@/components/ui/dropdown-menu';
import { openSettings } from '@/features/settings/settings-navigation';

import { useChannelConnectionQuery } from './msg-channels.query';
import {
  MESSAGING_CHANNEL_LABELS,
  MESSAGING_CHANNEL_TYPES,
  MessagingChannelTypes,
  MESSAGING_DELIVERY_OFF,
  type MessagingDeliveryChannel,
} from './msg-channels.types';

type DeliveryChannelDropdownProps = {
  channel: MessagingDeliveryChannel;
  onChange: (channel: MessagingDeliveryChannel) => void;
};

/** Picks the messaging channel a delivery goes to. A channel needs a live conversation to be picked. */
export function DeliveryChannelDropdown({
  channel,
  onChange,
}: DeliveryChannelDropdownProps) {
  const connections = {
    [MessagingChannelTypes.IMESSAGE]: useChannelConnectionQuery(
      MessagingChannelTypes.IMESSAGE
    ).data,
    [MessagingChannelTypes.WHATSAPP_BUSINESS]: useChannelConnectionQuery(
      MessagingChannelTypes.WHATSAPP_BUSINESS
    ).data,
  };
  const connected = MESSAGING_CHANNEL_TYPES.filter(
    (type) => connections[type]?.identifier
  );

  if (connected.length === 0 && channel === MESSAGING_DELIVERY_OFF) {
    return (
      <Button
        variant="outline"
        size="sm"
        onClick={() => openSettings('Channels')}
      >
        Connect
      </Button>
    );
  }

  return (
    <DropdownMenu.Root>
      <DropdownMenu.Trigger asChild>
        <Button variant="outline" size="sm" className="gap-1.5">
          {channel === MESSAGING_DELIVERY_OFF
            ? 'Off'
            : MESSAGING_CHANNEL_LABELS[channel]}
          <Icons.chevronDown className="size-3.5" />
        </Button>
      </DropdownMenu.Trigger>
      <DropdownMenu.Content align="end" className="min-w-40">
        <DropdownMenu.RadioGroup
          value={channel}
          onValueChange={(value) => onChange(value as MessagingDeliveryChannel)}
        >
          <DropdownMenu.RadioItem value={MESSAGING_DELIVERY_OFF}>
            Off
          </DropdownMenu.RadioItem>
          {connected.map((type) => (
            <DropdownMenu.RadioItem
              key={type}
              value={type}
              disabled={!connections[type]?.has_active_conversation}
            >
              {connections[type]?.has_active_conversation
                ? MESSAGING_CHANNEL_LABELS[type]
                : `${MESSAGING_CHANNEL_LABELS[type]} (text to enable)`}
            </DropdownMenu.RadioItem>
          ))}
        </DropdownMenu.RadioGroup>
      </DropdownMenu.Content>
    </DropdownMenu.Root>
  );
}
